import { gql } from "@apollo/client";

const GET_INVITATIONS = gql`
  query {
    get_student_profile {
      invitations {
        _id
        class_name
        avatar
        class_description
        class_code
        is_private
      }
    }
  }
`;

const GET_COMPLETED = gql`
  query {
    get_student_profile {
      lesson_completed {
        class {
          class_name
          class_description
        }

        lessons {
          _id
          lesson_name
        }
      }

      wait_list {
        _id
        class_code
        created_by {
          full_name
          avatar
        }
        students {
          student {
            _id
            full_name
          }
          date_joined
        }
        avatar
        class_name
        class_description
        lessons {
          _id
        }
        no_of_students
        paid_class
        plan
      }
    }
  }
`;

const GET_CARDS = gql`
  query {
    get_student_profile {
      authorization {
        card_type
        last4
        bank
        reusable
      }
      card {
        last_4digits
        card_type
      }
    }
  }
`;

const GET_CLASSES = gql`
  query {
    joined_classes {
      class {
        _id
        class_name
        class_code

        lessons {
          _id
          lesson_name
          objectives
          estimated_reading_time
          lesson_locked
          lesson_content
          no_of_comments
        }
      }
    }
  }
`;

export { GET_INVITATIONS, GET_CLASSES, GET_COMPLETED, GET_CARDS };
